module.exports = __webpack_public_path__ + "img/SLT_0731-Bearbeitet.2006ee6a.jpg";